import { FormControlLabel } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import React from 'react';
import { CheckboxProps } from '@mui/material/Checkbox/Checkbox';

interface CheckBoxProps extends CheckboxProps {
    name: string;
    label?: string;
}
export function CheckBox(props: CheckBoxProps) {
    return <FormControlLabel control={<Checkbox {...props} />} label={props.label || props.name} />;
}
